const postTypes = {
  ARTICLE: 'article',
  POST: 'post',
  PAGE: 'page',
  TEMPLATE: 'template',
};

export default postTypes;
